import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const deliveryModeEndpoint = ENDPOINTS.DELIVERY_MODE;

// Category API
export const deliveryModeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["deliveryModes"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDeliveryModes: builder.query({
        query: (payload) => `${deliveryModeEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "deliveryModes" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addDeliveryMode: builder.mutation({
        query: (requestData) => ({
          url: `${deliveryModeEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "deliveryModes" }],
      }),
      updateDeliveryMode: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${deliveryModeEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "deliveryModes" }],
      }),
      deleteDeliveryMode: builder.mutation({
        query: (id) => ({
          url: `${deliveryModeEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "deliveryModes" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetDeliveryModesQuery,
  useAddDeliveryModeMutation,
  useDeleteDeliveryModeMutation,
  useUpdateDeliveryModeMutation,
} = deliveryModeApi;
